exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreementPosition_8zKwZ {\n    position: relative;\n    width: 100%;\n    font-size: 15px;\n}\n\n@media print {\n    @page {\n        size: letter;\n        margin: 0pt;\n    }\n\n    .agreementPosition_8zKwZ {\n        font-size: 7pt;\n    }\n\n    .displayNone_27uQu {\n        display: none;\n    }\n}\n", ""]);

// exports
exports.locals = {
	"agreementPosition": "agreementPosition_8zKwZ",
	"displayNone": "displayNone_27uQu"
};